import { createContext, Dispatch } from 'react';
import { IListItem, IDepartmentList, EnterpriseRoleType } from '@umu/umu-types';

interface ISelectedMap {
    [key: string]: IListItem;
}
interface IUplevelIdMap {
    [key: string]: string;
}
interface IExcludeMap {
    [key: string]: string;
}
export interface IPageInfo {
    count: number;
    currentPage: number;
    totalPage: number;
    size: number;
}

export interface IUplevelDepartment {
    [key: string]: IListItem;
}

export interface IDepartmentCache {
    currDepartmentId: string;
    currDepartmentName: string;
    upLevelDepartmentId: string;
    parents: IDepartmentList[];
    children: IDepartmentList[];
}
export interface IDialogStates {
    departmentCache: IDepartmentCache; // 当前部门信息缓存
    uplevelDepartment: IUplevelDepartment; // 所有可管理部门列表及其父部门列表
    uplevelIdMap: IUplevelIdMap; // 部门数结构，只是有管理权限的部门树
    enterpriseName: string;
    dataList: IListItem[]; // 待选去列表
    selectedList: IListItem[];
    selectedMap: ISelectedMap; // 已选中的map
    excludeMap: IExcludeMap; // 已选中的默认不显示的数据
    searchList: IListItem[];
    isSearchMode: boolean;
    pageInfo: IPageInfo;
    ts: number;
    hasAllPermissionRoles: EnterpriseRoleType[];
}
export enum DIALOG_ACTION_TYPE {
    SET_DATALIST = 1, // 设置待选列表数据
    SET_DATAITEM = 2, // 选中或者移除选中
    SET_DATASUG = 3, // 搜索结果列表
    SET_CACHE = 4, // 当前部门信息、企业名称缓存
    SET_DEFAULT_SELECTED_LIST = 5, // 默认选择的部门列表
    SET_DEFAULT_SELECTED_DATAINFO = 6,
    SET_UPLEVEL_DEPARTMENT = 7, // 所有访问权限的部门列表和部门树。
    SET_ALL_LIST_CHECKED = 8, // 全选或取消动作
    UPDATE_SELECTED_MAP = 9,
    CLEAN = 100,
}
export interface IDialogAction {
    type: DIALOG_ACTION_TYPE;
    payload: any;
}
export interface IDialogProps {
    state: IDialogStates;
    dispatch: Dispatch<IDialogAction>;
}

export const initState: IDialogStates = {
    enterpriseName: '',
    uplevelDepartment: {},
    uplevelIdMap: {},
    departmentCache: {
        currDepartmentId: '0',
        currDepartmentName: '',
        upLevelDepartmentId: '-1',
        parents: [],
        children: [],
    },
    dataList: [],
    selectedList: [],
    searchList: [],
    ts: 0,
    pageInfo: {
        count: 0,
        currentPage: 1,
        totalPage: 1,
        size: 40,
    },
    isSearchMode: false,
    selectedMap: {},
    excludeMap: {},
    hasAllPermissionRoles: [EnterpriseRoleType.MANAGE, EnterpriseRoleType.ADMIN],
};
export const DialogContext = createContext<IDialogProps>({} as IDialogProps);
